import React from 'react';
import { TextField, Grid, Divider } from "@mui/material";
import { Box } from "@mui/system";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import NCRFormHeading from '../NCRFormHeading';
import NCRFormLabel from '../NCRFormLabel';
import NCRMultilineTextfields from '../NCRMultilineTextfields';
import NCRTextField from '../NCRTextField';

export default function AffectedItems({ content, onChange }) {

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const parsedValue = name === "affected_item_qty" ? parseInt(value, 10) || null : value;
    onChange({ [name]: parsedValue });
  };

  const theme = createTheme({
    components: {
      MuiSelect: {
        styleOverrides: {
          select: {
            fontSize: "14px",
            fontWeight: 400,
            color: "rgba(84, 84, 84, 1)",
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            "&::placeholder": {
              fontSize: "14px",
              fontWeight: 400,
              color: "rgba(84, 84, 84, 1)",
              opacity: 1,
            },
          },
        },
      },
    },
  });

  return (
    <>
      <ThemeProvider theme={theme}>
        <Box>
          <Box sx={{ p: 3 }}>
            <Box>
              <NCRFormHeading tooltipData={
                [
                  { description: "A detailed description of the item, part, or component affected." },
                ]
              }>
                Affected items/ Component
              </NCRFormHeading>
            </Box>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Box sx={{ mb: 2 }}>
                    <Grid container alignItems="center">
                      <Grid item xs={4}>
                        <NCRFormLabel isRequired={true} >Part/ Component number:</NCRFormLabel>
                      </Grid>
                      <Grid item xs={8}>
                        <NCRTextField
                          placeholder="Enter part/component"
                          name='affected_item_component_no'
                          onChange={handleInputChange}
                          value={content.formData.affected_item_component_no || ''}
                          disabled={content.inputDisable || (content.label === 'edit' && content.userData?.roleCode !== 'CLTADM')}
                          error={!!content?.errors?.affected_item_component_no}
                          maxLength={250}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box sx={{ mb: 2 }}>
                    <Grid container alignItems="center">
                      <Grid item xs={4}>
                        <NCRFormLabel isRequired={true} >Revision:</NCRFormLabel>
                      </Grid>
                      <Grid item xs={8}>
                        <NCRTextField
                          placeholder="Enter revision"
                          name='affected_item_revision'
                          onChange={handleInputChange}
                          value={content.formData.affected_item_revision || ''}
                          disabled={content.inputDisable || (content.label === 'edit' && content.userData?.roleCode !== 'CLTADM')}
                          type="text"
                          error={!!content?.errors?.affected_item_revision}
                          maxLength={250}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box sx={{ mb: 2 }}>
                    <Grid container alignItems="center">
                      <Grid item xs={4}>
                        <NCRFormLabel isRequired={true} >Quantity:</NCRFormLabel>
                      </Grid>
                      <Grid item xs={8}>
                        <TextField
                          size="small"
                          placeholder="Enter quantity"
                          name='affected_item_qty'
                          onChange={handleInputChange}
                          value={content.formData.affected_item_qty || ''}
                          disabled={content.inputDisable}
                          type="number"
                          error={!!content?.errors?.affected_item_qty}
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Box sx={{ mb: 2 }}>
                    <Grid container alignItems="center">
                      <Grid item xs={4}>
                        <NCRFormLabel isRequired={true} >Description:</NCRFormLabel>
                      </Grid>
                      <Grid item xs={8}>
                        <NCRTextField
                          size="small"
                          sx={{ width: '100%' }}
                          placeholder="Enter description"
                          name='affected_item_description'
                          onChange={handleInputChange}
                          value={content.formData.affected_item_description || ''}
                          disabled={content.inputDisable || (content.label === 'edit' && content.userData?.roleCode !== 'CLTADM')}
                          error={!!content?.errors?.affected_item_description}
                          maxLength={250}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Box sx={{ mb: 2 }}>
                    <Grid container alignItems="center">
                      <Grid item xs={4}>
                        <NCRFormLabel isRequired={true} >Supplier or Customer name:</NCRFormLabel>
                      </Grid>
                      <Grid item xs={8}>
                        <NCRTextField
                          size="small"
                          sx={{ width: '100%' }}
                          placeholder="Enter name"
                          name='affected_item_supplier_cust_name'
                          onChange={handleInputChange}
                          value={content.formData.affected_item_supplier_cust_name || ''}
                          disabled={content.inputDisable}
                          error={!!content?.errors?.affected_item_supplier_cust_name}
                          maxLength={250}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ flexGrow: 1 }}>
              <Grid item xs={4}>
                <NCRFormLabel sx={{ mb: 1 }}>Remarks (Traceability reference):</NCRFormLabel>
              </Grid>
              <Grid item xs={8}>
                <NCRMultilineTextfields
                  name="affected_item_remarks"
                  value={content.formData.affected_item_remarks || ""}
                  onChange={handleInputChange}
                  disabled={content.inputDisable}
                  placeholder="Enter remarks (traceability reference)"
                />
              </Grid>
            </Box>
          </Box>
          <Divider sx={{ mt: 1.5, mb: 0.5 }} />
        </Box>
      </ThemeProvider>
    </>
  );
};
